import React from "react";
import { Icon } from "@iconify/react";

function CheckoutIcon() {
  return (
    <div>
      <Icon icon="ion:return-down-forward-outline" width="18" height="18" />
    </div>
  );
}

export default CheckoutIcon;
